import { render, staticRenderFns } from "./GerenciarTurmas.vue?vue&type=template&id=8c982fe6&scoped=true&"
import script from "./GerenciarTurmas.vue?vue&type=script&lang=js&"
export * from "./GerenciarTurmas.vue?vue&type=script&lang=js&"
import style0 from "./GerenciarTurmas.vue?vue&type=style&index=0&id=8c982fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c982fe6",
  null
  
)

export default component.exports